import { flow } from 'fp-ts/function';
import { get, size, take } from 'lodash/fp';
import { createSelector } from 'reselect';

import { Route } from '@mews-distributor/common';

import { getCurrentRoute } from '../../modules/app/selectors';
import { getRateCompareFeature } from '../../modules/configuration/selectors';
import { getCurrentDateAvailableCategories } from '../../selectors/availability';

export const shouldRateCompareRender = createSelector(
    getRateCompareFeature,
    getCurrentRoute,
    getCurrentDateAvailableCategories,
    (rateCompare, currentRoute, availableCategories) =>
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        get('isEnabled', rateCompare) && currentRoute === Route.SpaceCategories && size(availableCategories) > 0
);

export const getCompetitors = flow(getRateCompareFeature, get('competitors'), take(3));

export const getCompetitorPriceRelativeAdjustment = flow(
    getRateCompareFeature,
    get('competitorPriceRelativeAdjustment')
);

export const getRateDescription = flow(getRateCompareFeature, get('rateDescription'));
